import type { GameState } from '@thicket/core';
import { html } from 'lit-html';
import { app, BIOME_NAMES, update } from './app.js';
import { startTour } from './tour.js';

const go = (tab: 'settings', anchor?: string) => update(() => {
  app.tab = tab;
  history.replaceState(null, '', `${app.dev ? '/dev' : ''}/${tab}`);
  window.scrollTo(0, 0);
  if (anchor) requestAnimationFrame(() => document.getElementById(anchor)?.scrollIntoView({ block: 'start' }));
});

const row = (title: string, sub: string, onClick: () => void) => html`<button class="group-row" @click=${onClick}>
  <span><span class="title">${title}</span>${sub ? html`<span class="small muted">${sub}</span>` : ''}</span>
  <span class="chev" aria-hidden="true">›</span></button>`;

/** The More tab: everything that doesn't need a tab of its own, in grouped lists. */
export function moreView(s: GameState) {
  return html`
    <p class="group-title">Garden</p>
    <div class="group">
      ${row('Starting place', `Your garden is in the ${BIOME_NAMES[s.profile.starterBiome].toLowerCase()}`, () => go('settings', 'starting-place'))}
    </div>
    <p class="group-title">You</p>
    <div class="group">
      ${row('Settings', 'Your day, reminders, rest, importing tasks', () => go('settings'))}
      <a class="group-row" href="/account"><span><span class="title">Account</span><span class="small muted">Passkeys, connected apps like Claude, devices</span></span><span class="chev" aria-hidden="true">›</span></a>
    </div>
    <p class="group-title">Help</p>
    <div class="group">
      ${row('Take the tour', 'A one-minute walk through Thicket', () => startTour())}
    </div>`;
}
